// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"WjH8TkzdMoR9RvHixPf5"};